import { useAtom } from "jotai/react";
import { HeaderV2ContentStore } from "../stores/header-v2-content-store";
import { HeaderV2LayoutStore } from "../stores/header-v2-layout-store";
import { HeaderV2ProgressStore } from "../stores/header-v2-progress-store";

function useHeaderV2Store() {
  const [headerV2LayoutStore, setHeaderV2LayoutStore] = useAtom(HeaderV2LayoutStore);
  const [headerV2ContentStore, setHeaderV2ContentStore] = useAtom(HeaderV2ContentStore);
  const [headerV2ProgressStore, setHeaderV2ProgressStore] = useAtom(HeaderV2ProgressStore);

  return {
    headerV2LayoutStore,
    headerV2ContentStore,
    headerV2ProgressStore,
    setHeaderV2LayoutStore,
    setHeaderV2ContentStore,
    setHeaderV2ProgressStore,
  };
}

export default useHeaderV2Store;
